import {isEmpty, isNumber} from 'lodash';
import {BASE_FORM_REQUEST_DEVICE} from './constants';

const validateFieldsForm = (requestDeviceForm) => {
  const fieldsForm = requestDeviceForm.requestType === 'D' ?
    {...BASE_FORM_REQUEST_DEVICE, 'motiveCode': 'Motivo'} : BASE_FORM_REQUEST_DEVICE;

  let error = {
    'field': '',
    'error': false,
  };

  const errorArr = Object.keys(fieldsForm);
  errorArr.forEach((errorName) => {
    const field = requestDeviceForm[errorName];
    // convert the number to string to validate if is empty
    const selectField = isNumber(field) && isNaN(field) === false ? `${field}` : field;
    if (isEmpty(selectField)) {
      error = {
        'field': fieldsForm[errorName],
        'error': true,
      };
    }
  });

  return error;
};

export const validateErrorsRequestDevice = (requestDeviceForm) => {
  const validateForm = validateFieldsForm(requestDeviceForm);

  if (validateForm.error) {
    return {
      'error': true,
      'message': `El campo ${validateForm.field} es requerido`,
    };
  }
  return {
    'error': false,
    'message': null,
  };
};

export const parseMotives = (list) => {
  return list.map((item) => ({
    'text': item.description,
    'value': item.motiveCode,
  }));
};

export const parseVehiclesInfo = (list) => {
  return list.map((item, idx) => ({
    'key': idx,
    'text': item.chassis,
    'value': item.chassis,
  }));
};
